import * as React from "react";

function SvgIconFacebook(props) {
  return (
    <svg width={24} height={24} {...props}>
      <path
        className="social-svg__path"
        fill="#FFF"
        fillRule="evenodd"
        d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.593 1.323-1.325V1.325C24 .593 23.407 0 22.675 0z"
      />
    </svg>
  );
}

export default SvgIconFacebook;
